// eslint-disable-next-line no-shadow
export enum HubriseLanguageCode {
    AR = 'ar',
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    PT = 'pt'
}
